import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MainStore from '@src/pages/main/store';
import Page from '../../components/page';
import PageSwiper from '@src/components/swiper/page-swiper';
import MainKv from '@src/pages/main/components/main-kv';
import News from '@src/pages/main/components/news';
import Feature from '@src/pages/main/components/feature';
import Clan from '@src/pages/main/components/clan';
import Strategy from '@src/pages/main/components/strategy';
import Audition from '@src/pages/main/components/audition';
import FollowUs from '@src/pages/main/components/follow-us';
import CommonHeader from '@src/business-components/common-header';
import CommonFooterModal from '@src/business-components/common-footer-modal';
import FloatRight from '@src/pages/float-right';
import HarmonyDownloadModal from '@src/business-components/harmony-download-modal';

const styles = require('./index.less');

const Main = () => {
  const store = useStore(() => new MainStore());
  return (
    <Page className={styles.root}>
      <CommonHeader store={store.commonHeaderStore} />
      <PageSwiper store={store.pageSwiperStore}>
        <div className={styles.swiperItem} data-name="首页">
          <MainKv store={store.mainKvStore} onOpenHarmonyDownloadModal={store.openHarmonyDownloadModal} />
        </div>
        <div className={styles.swiperItem} data-name="新闻">
          <News store={store.newsStore} />
        </div>
        <div className={styles.swiperItem} data-name="卖点">
          <Feature store={store.featureStore} />
        </div>
        <div className={styles.swiperItem} data-name="门派">
          <Clan store={store.clanStore} />
        </div>
        <div className={styles.swiperItem} data-name="攻略">
          <Strategy store={store.strategyStore} />
        </div>
        <div className={styles.swiperItem} data-name="视听中心">
          <Audition store={store.auditionStore} />
        </div>
        <div className={styles.swiperItem} data-name="关注我们">
          <FollowUs store={store.followUsStore} />
        </div>
      </PageSwiper>
      <CommonFooterModal showTrigger={store.pageSwiperStore.baseSwiperStore.activeIndex === store.swiper.length - 1} onVisibleChange={store.setFooterVisible} />

      <HarmonyDownloadModal
        visible={store.isHarmonyDownloadModalOpen}
        downloadUrl={store.mainKvStore.downloadUrl.harmony}
        onClose={store.closeHarmonyDownloadModal}
      />

      {store.pageSwiperStore.baseSwiperStore.activeIndex !== 0 && <FloatRight store={store.floatRightStore} />}
    </Page>
  );
};

export default observer(Main);
